(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["social-sharing"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pf-social')) {
    customElements.define('pf-social', class extends HTMLElement {
      connectedCallback() {
        if (this.pfReady) return;
        this.pfReady = true;
        this.querySelectorAll('[data-pf-platform]').forEach(button => button.addEventListener('click', async () => {
          const platform = button.dataset.pfPlatform;
          if (navigator.share) {
            try {
              await navigator.share({ title: this.dataset.title, url: this.dataset.url });
              return;
            } catch (error) {
              if (error.name === 'AbortError') return;
            }
          }
          await this.copyLink();
          this.querySelector('[role="status"]').textContent += ' Apri ' + platform + ' e incolla il link in un messaggio o dove consentito.';
        }));
        this.querySelector('[data-pf-copy]').addEventListener('click', () => this.copyLink());
        this.querySelector('[data-pf-share]').addEventListener('click', async () => {
          if (!navigator.share) {
            await this.copyLink();
            return;
          }
          try {
            await navigator.share({ title: this.dataset.title, url: this.dataset.url });
          } catch (error) {
            if (error.name !== 'AbortError') await this.copyLink();
          }
        });
      }
      async copyLink() {
        const status = this.querySelector('[role="status"]');
        try {
          if (!navigator.clipboard) throw new Error('clipboard unavailable');
          await navigator.clipboard.writeText(this.dataset.url);
          this.querySelector('input').hidden = true;
          status.textContent = 'Link copiato! Puoi incollarlo nei messaggi o sui social.';
        } catch (error) {
          const field = this.querySelector('input');
          field.hidden = false;
          field.focus();
          field.select();
          status.textContent = 'Copia il link selezionato qui sotto e incollalo dove desideri.';
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
